import React, { useContext, useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import { twMerge } from 'tailwind-merge';
import { Icon, Tabs } from '@scale/scaleui';
import { StepCard } from 'react-scale/components/scalers/tasks/ThreadedInteraction/step/StepCard';
import JSONataLinterPlayground, {
  JSONataExpression,
} from 'react-scale/corp/components/ChatTaskFormatter/components/JSONataLinterPlayground';
import { useChatStoreExtract } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';
import { ChatTaskContext } from '../contexts/ChatTaskContext';

export const LinterHelper = () => {
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const jsonataContextList = useChatStoreExtract(state => state.jsonataContextList);
  const [open, setOpen] = useState(true);
  const [tabs, setTabs] = useState<{ id: string }[]>([]);
  const [activeTab, setActiveTab] = useState<string>('');
  const taskContext = useContext(ChatTaskContext);

  useEffect(() => {
    if (!jsonataContextList?.length) {
      return;
    }

    const linterNames = jsonataContextList.map(x => x.metadata?.lintRuleName);

    if (linterNames.length) {
      setTabs(linterNames.map(x => ({ id: x ?? '' })));
      setActiveTab(linterNames[0] ?? '');
    }
  }, [jsonataContextList]);

  if (!jsonataContextList?.length) {
    return null;
  }

  // Only render on linter config page, not on task page
  if (taskContext.assignmentId !== '64f1688f4e9f662f72a5088d') {
    return null;
  }

  return (
    <Draggable
      onStart={() => setIsDragging(true)}
      onStop={() => setIsDragging(false)}
      handle=".handle"
      grid={[25, 25]}
      bounds="body"
    >
      <div
        className={`chat-linter-panel-handle fixed bottom-[5%] left-[5%] z-20 rounded w-[${
          open ? '65%' : '30%'
        }] h-[${open ? '65%' : '30%'}] max-h-[85%] flex flex-col gap-2 overflow-hidden`}
      >
        <StepCard className="flex-1 overflow-auto border-neutral-150">
          <StepCard.Header
            className={twMerge(
              'handle bg-primary-100',
              isDragging ? 'cursor-grabbing' : 'cursor-grab',
            )}
          >
            <StepCard.HeaderLeft>
              <StepCard.Icon icon="grip-vertical" />
              <StepCard.HeaderColumn>
                <StepCard.Title>
                  <div className="flex flex-row gap-2">JSONata Playground</div>
                </StepCard.Title>
              </StepCard.HeaderColumn>
            </StepCard.HeaderLeft>
            <StepCard.HeaderRight className="text-primary-600">
              <Icon
                icon={open ? 'chevron-up' : 'chevron-down'}
                size="lg"
                onClick={() => setOpen(!open)}
              />
            </StepCard.HeaderRight>
          </StepCard.Header>
          {open && (
            <StepCard.Body className="overflow-y-auto">
              <Tabs onChange={setActiveTab} tabs={tabs} value={activeTab} />
              <br />
              <div className="mt-2">
                {' '}
                {jsonataContextList?.map(x => {
                  const context = x.metadata;
                  if (!context) return null;

                  return (
                    <JSONataLinterPlayground
                      key={context.lintRuleName}
                      ruleName={context.lintRuleName}
                      hide={context.lintRuleName !== activeTab}
                      context={context.jsonataContext?.source}
                      expressions={
                        (context.jsonataContext?.expressions as JSONataExpression[]) ?? []
                      }
                      operator={context.jsonataContext?.operator ?? ''}
                    />
                  );
                })}
              </div>
            </StepCard.Body>
          )}
        </StepCard>
      </div>
    </Draggable>
  );
};
